import * as React from "react";

function SvgRounded2Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1609.5 128.5h-9.5c0 10.9-8.9 19.8-19.8 19.8H19.8C8.9 148.4 0 139.5 0 128.5l-10 .2v83.1h1619.5v-83.3z" /></svg>;
}

export default SvgRounded2Inverted;